import React from "react";
import {
  View,
  Modal,
  Text,
  TouchableOpacity,
  FlatList,
  ActivityIndicator,
  Image,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import Ionicons from "@expo/vector-icons/Ionicons";
import { router } from "expo-router";
import i18n from "../../locales/i18n";
import Checkbox from "expo-checkbox";
import { Toast } from "react-native-toast-notifications";
interface BillData {
  profit: number;
  created_at: string;
}

interface Product {
  id_product: number;
  product_name: string;
  quantity: number;
}

interface BillModalProps {
  OpenModal: boolean;
  setOpenModel: (open: boolean) => void;
  billData: BillData;
  totalPrice: number;
  time: string;
  date: string;
  factureId: number | null;
  ShowmoRe: boolean;
  SetShowMore: (show: boolean) => void;
  allProducts: Product[];
  buttonSpinner: boolean;
  SetOpenCam: (open: boolean) => void;
  setTotalOther: (total: number) => void;
  setSelectedProducts: (products: any[]) => void;
  setProducts: (products: any[]) => void;
  setAllProducts: (products: any[]) => void;
  locale: string;
  isChecked: boolean;
  setChecked: (checked: boolean) => void;
  selectedProduct: any[];
  clearCart: () => void;
}

const BillModal: React.FC<BillModalProps> = ({
  OpenModal,
  setOpenModel,
  billData,
  totalPrice,
  time,
  date,
  ShowmoRe,
  SetShowMore,
  allProducts,
  buttonSpinner,
  SetOpenCam,
  setTotalOther,
  setSelectedProducts,
  setProducts,
  setAllProducts,
  locale,
  factureId,
  isChecked,
  setChecked,
  selectedProduct,
  clearCart,
}) => {
  return (
    <Modal visible={OpenModal} animationType="fade">
      <View className="flex    items-center justify-center w-full h-screen     relative    p-4      ">
        <Text className="text-2xl text-black   mb-4 text-center font-bold ">
          {i18n.t("sellseccess")}
        </Text>
        <View className="flex items-center  justify-center ">
          <Image
            source={require("../../assets/images/success.png")}
            className="rounded-full w-36 h-36 "
          />
        </View>

        <View className="    border   w-full  p-4 ">
          <View
            className={` ${
              locale == "ar" ? "flex-row" : "flex-row-reverse"
            } items-center px-4 justify-between  `}
          >
            <View className="flex-row gap-x-4 items-center">
              <Text className="text-black text-lg">{date}</Text>
              <Text className=" text-lg text-black ">{time}</Text>
            </View>
            <Text className="text-xl font-semibold text-black ">
              {i18n.t("bill")}
            </Text>
          </View>
          <View
            className={`
              ${locale == "ar" ? "flex-row" : "flex-row-reverse"}   
            mt-4  items-center justify-between`}
          >
            <View className="flex  items-center ">
              <Text className=" text-xl font-bold text-black ">
                {i18n.t("profit")}
              </Text>
              <Text className="text-black mt-2 text-xl font-bold ">
                {billData?.profit}
              </Text>
            </View>
            <View className="flex  items-center ">
              <Text className=" text-xl text-black font-bold ">
                {" "}
                {i18n.t("total")}
              </Text>
              <Text className="text-black mt-2 text-xl font-bold ">
                {totalPrice}
              </Text>
            </View>
          </View>

          {!ShowmoRe && (
            <View
              className={`         
                          ${locale == "ar" ? "items-end" : "items-start"}   
              flex   `}
            >
              <TouchableOpacity
                onPress={() => {
                  SetShowMore(true);
                }}
                className={`    flex-row     flex   items-center mt-4 gap-x-2`}
              >
                <Ionicons name="eye" size={24} color="black" />
                <Text className="text-black"> {i18n.t("showmore")}</Text>
              </TouchableOpacity>
            </View>
          )}
          {ShowmoRe && (
            <>
              <View className="flex flex-row  mt-4   justify-between  items-center ">
                <FlatList
                  data={allProducts}
                  horizontal={true}
                  contentContainerStyle={{
                    justifyContent: "flex-end",
                    flexGrow: 1,
                  }}
                  showsHorizontalScrollIndicator={false}
                  keyExtractor={(item) => item.id_product.toString()}
                  renderItem={({ item, index }) => (
                    <View
                      key={index}
                      className="  items-center mx-2 px-2 py-1 flex flex-row  justify-center border-2 rounded-full  border-black "
                    >
                      <Text className="    text-black  text-xl  font-bold     ">
                        {item.product_name}
                      </Text>
                      <View className="w-8 h-8  items-center justify-center flex mx-1 rounded-full  bg-red-500  ">
                        <Text className=" text-lg font-bold text-white text-center  ">
                          {item.quantity}
                        </Text>
                      </View>
                    </View>
                  )}
                />
              </View>
              <View
                className={`         
                            ${locale == "ar" ? "items-end" : "items-start"}   
              flex  `}
              >
                <TouchableOpacity
                  onPress={() => {
                    SetShowMore(false);
                  }}
                  className={`    flex-row     flex   items-center mt-4 gap-x-2`}
                >
                  <Ionicons name="eye-off" size={24} color="black" />
                  <Text className="text-black"> {i18n.t("showless")}</Text>
                </TouchableOpacity>
              </View>
            </>
          )}
          <TouchableOpacity
            onPress={() => {
              if (selectedProduct.length === 0) {
                Toast.show(i18n.t("pleaseaddproducts"), {
                  type: "danger",
                });
                return;
              }
              setChecked(true);

              router.push(
                `/dettes/add-dette?total=${totalPrice}&factureId=${factureId}` as any
              );
            }}
            className={`${
              locale == "fr"
                ? "flex-row items-end"
                : "flex-row-reverse items-start"
            }
        flex items-center  px-2 my-4 
          `}
          >
            <Checkbox
              style={{
                margin: 4,
              }}
              // disabled={selectedProduct.length == 0}
              value={isChecked}
              onValueChange={() => {
                if (isChecked === false) {
                  router.push(
                    `/dettes/add-dette?flag=comeFromBill&total=${totalPrice}&factureId=${factureId}`
                  );
                }
                setChecked(!isChecked);
              }}
            />

            <Text
              className={`${
                locale == "ar" ? "text-right" : "text-left"
              } text-lg font-semibold px-4`}
            >
              {i18n.t("addtodeptlist")}
            </Text>
          </TouchableOpacity>
        </View>

        {/* buttons  */}

        <View className="flex flex-row  justify-between  mt-8 gap-4">
          <TouchableOpacity
            style={{
              borderRadius: 15,
              marginTop: 10,
              overflow: "hidden",
            }}
            onPress={() => {
              setOpenModel(false);
              router.push("/(drawer)/bills");
            }}
          >
            <LinearGradient
              colors={["#FF7F7F", "#FF4C4C", "#CC0000"]}
              locations={[0, 0.28, 0.99]}
              style={{
                paddingHorizontal: 40,
                paddingVertical: 12,
                borderColor: "white",
                borderWidth: 1,
                borderRadius: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {buttonSpinner ? (
                <ActivityIndicator size="small" color={"black"} />
              ) : (
                <Text className=" text-white font-bold ">
                  {i18n.t("allbills")}{" "}
                </Text>
              )}
            </LinearGradient>
          </TouchableOpacity>

          <TouchableOpacity
            style={{
              borderRadius: 15,
              marginTop: 10,
              overflow: "hidden",
            }}
            onPress={() => {
              setOpenModel(false);
              SetOpenCam(true);
              setTotalOther(0);
              clearCart(); // Use Redux clearCart instead of manual clearing
              setProducts([]);
              setAllProducts([]);
            }}
          >
            <LinearGradient
              colors={["#259A9D", "#146C94", "#003789"]}
              locations={[0, 0.28, 0.99]}
              style={{
                paddingHorizontal: 40,
                paddingVertical: 12,
                borderColor: "white",
                borderWidth: 1,
                borderRadius: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {buttonSpinner ? (
                <ActivityIndicator size="small" color={"black"} />
              ) : (
                <Text className=" text-white font-bold">{i18n.t("new")} </Text>
              )}
            </LinearGradient>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

export default BillModal;
